import React, { useEffect, useState } from "react";
import api from "../../api";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend
);

const HourlyApiTrafficChart = () => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token =
          localStorage.getItem("access_token") ||
          sessionStorage.getItem("access_token");

        const config = {
          headers: { Authorization: `Bearer ${token}` },
        };

        const baseUrl = process.env.REACT_APP_API_URL;
        const response = await api.get(
          `${baseUrl}/chat/hourly-traffic`,
          config
        );

        const traffic = response.data.hourlyApiTraffic || [];

        const labels = traffic.map((item) => item.hour);
        const data = traffic.map((item) => item.count);

        setChartData({
          labels,
          datasets: [
            {
              label: "API Calls",
              data,
              fill: true,
              backgroundColor: "rgba(75, 192, 192, 0.15)",
              borderColor: "#009688",
              pointBackgroundColor: "#004D40",
              pointRadius: 4,
              pointHoverRadius: 6,
              tension: 0.3,
            },
          ],
        });
      } catch (error) {
        console.error("❌ Failed to fetch hourly API traffic:", error);
      }
    };

    fetchData();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw} API calls`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 5 },
        grid: { color: "rgba(0, 0, 0, 0.05)" },
        title: {
          display: true,
          text: "Number of API Calls",
          font: { size: 13, weight: "bold" },
        },
      },
      x: {
        grid: { display: false },
      },
    },
  };

  return (
    <div className="chart-card p-3 shadow-sm rounded mb-4 profile-i">
      <h5 className="fw-semibold mb-4">
        <span className="border-start border-4 border-dark ps-2">
          Hourly API Traffic
        </span>
      </h5>
      <div style={{ height: "300px", width: "100%" }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default HourlyApiTrafficChart;
